module.exports = __webpack_public_path__ + "static/img/progress_small.023ad4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_small.svg
// module id = sdkQ
// module chunks = 1